import Acne1 from "../assets/images/Acne/Acne1.png";
import Acne2 from "../assets/images/Acne/Acne2.png";
import Acne3 from "../assets/images/Acne/Acne3.png";
import Acne4 from "../assets/images/Acne/Acne4.png";
import Acne5 from "../assets/images/Acne/Acne5.png";
import Acne6 from "../assets/images/Acne/Acne6.png";
////////////////////////
import Actinic_keratosis from "../assets/images/Actinic keratosis/Actinic keratosis.png";
/////////////////////
import BaselCell1 from "../assets/images/Basal cell carcinoma/1.png";
import BaselCell2 from "../assets/images/Basal cell carcinoma/2.png";
import BaselCell3 from "../assets/images/Basal cell carcinoma/3.png";
import BaselCell4 from "../assets/images/Basal cell carcinoma/4.png";
import BaselCell5 from "../assets/images/Basal cell carcinoma/5.png";
/////////////////////////
import Blister1 from "../assets/images/Blister/1.png";
import Blister2 from "../assets/images/Blister/2.png";
import Blister3 from "../assets/images/Blister/3.png";
import Blister4 from "../assets/images/Blister/4.png";
import Blister5 from "../assets/images/Blister/5.png";
///////////////////////////
import Carbuncle1 from "../assets/images/Carbuncle/1.png";
import Carbuncle2 from "../assets/images/Carbuncle/2.png";
import Carbuncle3 from "../assets/images/Carbuncle/3.png";
import Carbuncle4 from "../assets/images/Carbuncle/4.png";
import Carbuncle5 from "../assets/images/Carbuncle/5.png";
//////////////////////
import Cellulitis1 from "../assets/images/Cellulitis/1.png";
import Cellulitis2 from "../assets/images/Cellulitis/2.png";
import Cellulitis3 from "../assets/images/Cellulitis/3.png";
import Cellulitis4 from "../assets/images/Cellulitis/4.png";
///////////////////
import Chickenpox from "../assets/images/Chickenpox/1.png";
/////////////////////////////////
import ColdSore from "../assets/images/Cold sore/1.png";
/////////////////////////////
import ContactDermatitis1 from "../assets/images/Contact dermatitis/1.png";
import ContactDermatitis2 from "../assets/images/Contact dermatitis/2.png";
import ContactDermatitis3 from "../assets/images/Contact dermatitis/3.png";
import ContactDermatitis4 from "../assets/images/Contact dermatitis/4.png";
import ContactDermatitis5 from "../assets/images/Contact dermatitis/5.png";

export const diseases = [
  {
    id: 1,
    title: "Avne",
    img: [Acne1, Acne2, Acne3, Acne4, Acne5, Acne6],
    paragraph:
      "occurs when skin cells called keratinocytes start to grow abnormally.",
  },
  {
    id: 2,
    title: "Actinic keratosis",
    img: [Actinic_keratosis],
    paragraph:
      "occurs when skin cells called keratinocytes start to grow abnormally.",
  },
  {
    id: 3,
    title: "Basal cell carcinoma",
    img: [BaselCell1, BaselCell2, BaselCell3, BaselCell4, BaselCell5],
    paragraph:
      "occurs when skin cells called keratinocytes start to grow abnormally.",
  },
  {
    id: 4,
    title: "Blister",
    img: [Blister1, Blister2, Blister3, Blister4, Blister5],
    paragraph:
      "occurs when skin cells called keratinocytes start to grow abnormally.",
  },
  {
    id: 5,
    title: "Carbuncle",
    img: [Carbuncle1, Carbuncle2, Carbuncle3, Carbuncle4, Carbuncle5],
    paragraph:
      "occurs when skin cells called keratinocytes start to grow abnormally.",
  },
  {
    id: 6,
    title: " Cellulitis",
    img: [Cellulitis1, Cellulitis2, Cellulitis3, Cellulitis4],
    paragraph:
      "occurs when skin cells called keratinocytes start to grow abnormally.",
  },
  {
    id: 7,
    title: " Chickenpox",
    img: [Chickenpox],
    paragraph:
      "occurs when skin cells called keratinocytes start to grow abnormally.",
  },
  {
    id: 8,
    title: " Cold sore",
    img: [ColdSore],
    paragraph:
      "occurs when skin cells called keratinocytes start to grow abnormally.",
  },
  {
    id: 9,
    title: " Contact Dermatitis5",
    img: [
      ContactDermatitis1,
      ContactDermatitis2,
      ContactDermatitis3,
      ContactDermatitis4,
      ContactDermatitis5,
    ],
    paragraph:
      "occurs when skin cells called keratinocytes start to grow abnormally.",
  },
];
